import { paths } from "src/routes/paths";
import {
  APPLICATION_TYPE_OPTIONS,
  ORGANISER_APPLICATION_TYPE_OPTIONS,
} from "./applicationConstants";

export function test(str: string) {
  console.log(str);
}

export const displayItemStatusColor = (item: any): string => {
  const reservationStartDate = item?.reservation?.start_date
    ? new Date(item.reservation.start_date)
    : null;

  if (item?.item_type === "tournamentapplication") {
    if (item?.application?.status === "cancelled" || item?.status === -1) {
      return "warning";
    }

    if (item?.paid === 1) {
      return "success";
    }

    return "info";
  }

  if (item?.status === -1) {
    return "warning";
  }

  if (
    item?.status === 1 &&
    reservationStartDate &&
    new Date() < reservationStartDate
  ) {
    return "info";
  }

  if (item?.status === 1) {
    return "success";
  }

  return "default";
};

export const displayItemStatusText = (item: any): string => {
  const reservationStartDate = item?.reservation?.start_date
    ? new Date(item.reservation.start_date)
    : null;

  if (item?.reservation?.cancellation_late === 1) {
    return "late_cancellation";
  }

  if (item?.status === -1) {
    return "cancelled";
  }

  if (
    item?.status === 1 &&
    reservationStartDate &&
    new Date() < reservationStartDate
  ) {
    return "future";
  }

  if (item?.status === 1) {
    return "completed";
  }

  if (item?.item_type === "tournamentapplication") {
    if (item?.paid === 1) return "completed";
    if (item?.status === 1) return "future";
  }

  return "default";
};

export const generateDates = (daysBeforeAndAfter: number): string[] => {
  const dates: string[] = [];
  const today = new Date();

  for (let i = -daysBeforeAndAfter; i <= daysBeforeAndAfter; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");

    dates.push(`${year}-${month}-${day}`);
  }

  return dates;
};

export const loadLabelsOfTransactionType = (type: string) => {
  if (type === APPLICATION_TYPE_OPTIONS[0].value) {
    //reservation
    return {
      checkout_success_title: "successful_reservation",
      checkout_complete_continue_btn: "continue_reservation",
      checkout_complete_items_btn: "my_reservations",
      checkout_complete_items_btn_path: paths.player.activities,
      checkout_complete_continue_btn_path: paths.sportproviders,
    };
  } else if (type === APPLICATION_TYPE_OPTIONS[2].value) {
    //training
    return {
      checkout_success_title: "successful_application",
      checkout_complete_continue_btn: "continue_application",
      checkout_complete_items_btn: "my_applications",
      checkout_complete_items_btn_path: paths.player.activities,
      checkout_complete_continue_btn_path: paths.sportproviders,
    };
  } else if (type === APPLICATION_TYPE_OPTIONS[4].value) {
    //pass
    return {
      checkout_success_title: "successful_pass_purchase",
      checkout_complete_continue_btn: "continue_shopping",
      checkout_complete_items_btn: "my_passes",
      checkout_complete_items_btn_path: paths.player.passestickets,
      checkout_complete_continue_btn_path: paths.sportproviders,
    };
  } else if (type === APPLICATION_TYPE_OPTIONS[5].value) {
    //ticket
    return {
      checkout_success_title: "successful_ticket_purchase",
      checkout_complete_continue_btn: "continue_shopping",
      checkout_complete_items_btn: "my_tickets",
      checkout_complete_items_btn_path: paths.player.passestickets,
      checkout_complete_continue_btn_path: paths.sportproviders,
    };
  } else if (type === ORGANISER_APPLICATION_TYPE_OPTIONS[0].value) {
    //tournamentapplication
    return {
      checkout_success_title: "successful_tournamentapplication_purchase",
      checkout_complete_continue_btn: "continue_shopping",
      checkout_complete_items_btn: "my_tournamentapplications",
      checkout_complete_items_btn_path: paths.player.activities,
      checkout_complete_continue_btn_path: paths.sportproviders,
    };
  }

  return {
    checkout_success_title: "successful_reservation",
    checkout_complete_continue_btn: "continue_reservation",
    checkout_complete_items_btn: "my_reservations",
    checkout_complete_items_btn_path: paths.player.activities,
    checkout_complete_continue_btn_path: paths.sportproviders,
  };
};

export const calculateFilledPercentage = (
  properties: string[],
  obj: Record<string, any>
): number => {
  if (!properties || !Array.isArray(properties) || properties.length === 0) {
    throw new Error("Properties list must be a non-empty array.");
  }

  let filledCount = 0;

  properties.forEach((property) => {
    const keys = property.split("."); // Support nested properties
    let value: any = obj;

    for (const key of keys) {
      value = value?.[key];
      if (value === undefined || value === null) {
        return; // If a value is null/undefined, skip to the next property
      }
    }

    // Check if the value is non-empty
    if (
      (typeof value === "string" && value.trim() !== "") || // Non-empty string
      (typeof value === "number" && !isNaN(value)) || // Valid number
      (Array.isArray(value) && value.length > 0) || // Non-empty array
      (typeof value === "object" && Object.keys(value).length > 0) // Non-empty object
    ) {
      filledCount++;
    }
  });

  // Calculate the percentage
  const percentage = (filledCount / properties.length) * 100;
  return Math.round(percentage * 100) / 100; // Round to 2 decimal places
};

// Simple cookie utility functions
export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? decodeURIComponent(match[2]) : null;
};

export const setCookie = (name: string, value: string, days = 365) => {
  const expires = new Date();
  expires.setDate(expires.getDate() + days);
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires.toUTCString()}; path=/`;
};
